import { ProducerStatus } from '@/feature/betslip-sbk/types';
import { OptionStatus, Supplier } from '@/feature/event-details-sbk/types';

export const isProducerDown = (
    producerStatuses: Partial<Record<Supplier, ProducerStatus>>,
    supplier?: Supplier
): boolean => (supplier ? producerStatuses[supplier] === 'DOWN' : false);

export const isOptionOpen = (optionStatus: OptionStatus, producerDown: boolean, isMarketPublished: boolean) => {
    return optionStatus === 'OPENED' && !producerDown && isMarketPublished;
};

export const isOptionSuspended = (optionStatus: OptionStatus, producerDown: boolean, isMarketPublished: boolean) => {
    return optionStatus === 'SUSPENDED' || producerDown || !isMarketPublished;
};
